import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../Auth/authSlice';
import { webview } from '../../../app/api/webview';
import { Box, Tabs, Tab, useMediaQuery, Grid } from '@mui/material';
import { getAuthTokenWithoutBasicForLeave } from '../utility/AuthKey';
import ComingSoon from './CommingSoon';
import Overlay from './Overlay';
import SkeletonLeaveManagement from '../skeletons/SkeletonLeaveManagement';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../context/Ability';
import { useTheme } from '@emotion/react';
import HolidayList from '../../../pages/HolidayList.jsx';

import {
  AddHomeWork,
  Approval,
  DateRange,
  DomainAdd,
  DomainDisabled,
  DomainVerification,
  EventAvailable,
  EventNote,
  ExitToApp,
  HomeWork,
  Settings,
  WorkOutline,
} from '@mui/icons-material';

const LeaveManagement = () => {
  const user = useSelector(selectCurrentUser);
  const [authKey, setAuthKey] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const ability = useAbility(AbilityContext);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  useEffect(() => {
    const context = {
      getStringValue: (key, defaultValue) => {
        const values = {
          REPORTING_HEAD_ID: user.details.travelData.userDetails.reportingHead.empID || '0',
          USERNAME: user.userName,
          PASSWORD: user.password,
        };
        return values[key] || defaultValue;
      },
    };

    const token = getAuthTokenWithoutBasicForLeave(context, user.username);
    setAuthKey(token);
  }, [user]);

  const handleTabChange = (event, newValue) => {
    window['ReactNativeWebView'] &&
        window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'webview', value: "leave module close" }));
    setTabIndex(newValue);
  };

  console.log(webview.Leave.MyLeave(authKey), 'Leave');
  let tabs;
  // const key = 'T+3Qfn+3acRBRrR4f8zGJwLf24HKZ5dY9AYZWtcMMgTJ2SWf/34AlUdU2Fiokzcc';
  // console.log(`https://gispm.thegatewaycorp.com/Open/WebView.aspx?AuthKey=${authKey}&IsWFH=1&IsLoginThroughMobile=1`);
  ability.can('create', 'Leave')
    ? (tabs = [
        {
          label: 'Leave',
          icon: <EventNote />,
          url: webview.Leave.MyLeave(authKey),
          comingSoon: true,
        },
        { label: 'Holiday List', icon: <DateRange />, url: webview.Holidays, comingSoon: false, component: true }, // Set comingSoon to true for unavailable tabs
        { label: 'WFH', icon: <AddHomeWork />, url: webview.Leave.MyWFH(authKey), comingSoon: true },
        { label: 'OOF', icon: <DomainAdd />, url: webview.Leave.MyOOF(authKey), comingSoon: true },
        {
          label: 'Leave Approval',
          icon: <EventAvailable />,
          url: webview.ApprovalPM.LeaveApproval(authKey),
          comingSoon: true,
        },
        {
          label: 'WFH Approval',
          icon: <HomeWork />,
          url: webview.ApprovalPM.WFHApproval(authKey),
          comingSoon: true,
        },
        {
          label: 'OOF Approval',
          icon: <DomainDisabled />,
          url: webview.ApprovalPM.OOFApproval(authKey),
          comingSoon: true,
        },
      ])
    : (tabs = [
        { label: 'Leave', icon: <EventNote />, url: webview.Leave.MyLeave(authKey), comingSoon: true },
        { label: 'Holiday List', icon: <DateRange />, url: webview.Holidays, comingSoon: false, component: true }, // Set comingSoon to true for unavailable tabs
        { label: 'WFH', icon: <AddHomeWork />, url: webview.Leave.MyWFH(authKey), comingSoon: true },
        { label: 'OOF', icon: <DomainAdd />, url: webview.Leave.MyOOF(authKey), comingSoon: true },
      ]);
  useEffect(() => {
    //sending the progress status to webview
    if (authKey) {
      console.log('url sent', tabs[tabIndex].url);
      window['ReactNativeWebView'] &&
        window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'webview', value: tabs[tabIndex].url }));
    }
  }, [authKey, tabIndex, tabs]);
  if (!authKey) {
    return <div>Loading...</div>;
  }
  return (
    <Box sx={{ width: '100%', backgroundColor: 'background.paper', p: 0 }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        aria-label="Leave Management tabs"
        variant={isMobile ? 'scrollable' : 'fullWidth'}
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          color: 'black',
          backgroundColor: 'background.default',
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          mb: 0,
          borderColor: 'divider',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,

          '& .MuiTab-root': {
            color: 'grey',
            minHeight: '48px',
            fontSize: {
              xs: '0.75rem',
              sm: '0.875rem',
              md: '1rem',
              lg: '1rem',
              xl: '1rem',
            },
            px: {
              xs: 1,
              sm: 1,
              md: 1,
            },
          },
          '& .Mui-selected': {
            color: 'black !important',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: 'text.primary',
            height: 2,
          },
          '& .MuiTabs-scrollButtons': {
            '&.Mui-disabled': {
              opacity: 0.5, // Makes the disabled button look inactive
              cursor: 'not-allowed', // Changes the cursor to indicate it's disabled
            },
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            icon={tab.icon}
            iconPosition="start"
            sx={{
              textTransform: 'none',
              // fontWeight: 'bold',
              fontSize: {
                xs: '0.75rem',
                sm: '0.875rem',
                md: '1rem',
                lg: '1rem',
                xl: '1rem',
              },
              px: {
                xs: 1,
                sm: 2,
                md: 3,
              },
            }}
          />
        ))}
      </Tabs>
      {/* <Box
        sx={{
          height: '82.5vh',
          borderRadius: '10px',
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderTop: 0,
          position: 'relative',
        }}
      > */}
      <Grid
        container
        sx={{
          height: 'calc(100vh - 130px)',
          borderRadius: '10px',
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderTop: 0,
          position: 'relative',
        }}
      >
        {tabs[tabIndex].comingSoon ? (
          <Box sx={{ background: 'white' }}>
            {/* <SkeletonLeaveManagement /> */}
            <Overlay />
          </Box>
        ) : tabs[tabIndex]?.component ? (
          <HolidayList />
        ) : (
          <embed
            src={tabs[tabIndex].url}
            height="100%"
            width="100%"
            style={{ border: 0 }}
            allow="cookies" // Ensure cookies are allowed
          />
        )}
      </Grid>
    </Box>
  );
};

export default LeaveManagement;
